import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import moment from 'moment';
import { useFormik, Form, FormikProvider } from 'formik';
import { makeStyles } from '@material-ui/styles';
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SaveIcon from '@material-ui/icons/Save';
import UpdateIcon from '@material-ui/icons/Update';
import Controls from '../controls/Controls';
import {
  baseUrl,
  paymentFrequencies,
  tariffTypes,
  titles,
  payoutMethods,
  languages,
  statuses
} from '../../utils/constants';
import { useSettingContext } from '../../context/setting_context';
import { useConstantsContext } from '../../context/constants_context';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0
    }
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  color: {
    backgroundColor: '#f5f5f5'
  },
  newButton: {
    position: 'absolute',
    right: '10px'
  }
}));

export default function ProviderDetail() {
  const classes = useStyles();
  const { doctor, setDoctor, providerId } = useSettingContext();
  const { towns, banks, bankBranches, suburbs } = useConstantsContext();
  const [expanded, setExpanded] = React.useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [providerCodes, setProviderCodes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: ''
  });

  useEffect(() => {
    getProviderDisciplines();
    // if (providerId > 0) {
    //   populateProvider(providerId);
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //   useEffect(() => {
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, [doctor]);

  const PersonalDetailsSchema = Yup.object().shape({
    provider: Yup.string()
      .min(2, 'Provider Name is too Short!')
      .max(50, 'Provider Name is too Long!')
      .required('Provider name required'),
    namasNo: Yup.string().required('Provider # is required'),
    paymentMethod_id: Yup.number().required('Payment Method is required'),
    tariffs: Yup.string().required('Tariff Group is required'),
    discipline_id: Yup.number().required('Discipline is required'),
    frequency: Yup.number().required('Frequency is required')
  });

  // const initialValue = {
  //   currentProduct
  // };

  const formik = useFormik({
    initialValues: doctor,
    enableReinitialize: true,
    validationSchema: PersonalDetailsSchema,
    onSubmit: (values) => {
      console.log('provider details 2', values);
      if (providerId > 0) {
        console.log('to providerId', providerId);
      } else {
        console.log('to update', values);
        values.captureDate = moment();
      }
    }
  });

  if (doctor.termdate) doctor.termdate = moment(doctor.termdate).format('yyyy-MM-DD');

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const populateProvider = async (providerId) => {
    if (providerId === '') {
      return;
    }
    setLoading(true);
    await axios(`${baseUrl}/api/setting/GetProvidersById?providerId=${providerId}`).then(
      (result) => {
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Provider not Found!: ${result.replyMessage}`, 'error');
        } else {
          console.log('retuned doctor', result.data[0]);
          setDoctor(result.data[0]);
        }
      },
      (error) => {
        notifyPopup(`Error in populateProvider!: ${error}`, 'error');
      }
    );
  };

  const getProviderDisciplines = () => {
    fetch(`${baseUrl}/api/setting/getProviderDisciplines`)
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('provider doctor list', result);
          setProviderCodes(result);
        },
        (error) => {
          notifyPopup(`Error in Retrieving Error Codes!: ${error}`, 'error');
        }
      );
  };

  const closePopup = () => {
    setOpenPopup(false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <Card>
      <CardContent>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate>
            <Typography variant="subtitle1" gutterBottom>
              Provider Setup...
            </Typography>
            <Grid container spacing={2} justifyContent="center" alignItems="center">
              <Grid item xs={12} sm={4}>
                <Controls.Input name="provider_id" label="Provider #" disabled />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Controls.Input name="namasNo" label="Provider #" />
              </Grid>
              <Grid item xs={12} sm={2}>
                <Controls.SelectJson name="status_id" label="Status" options={statuses} />
              </Grid>
              <Grid item xs={12} sm={5}>
                <Controls.Input name="provider" label="Provider Name" />
              </Grid>
              <Grid item xs={12} sm={5}>
                <Controls.Input name="add1" label="Address Line 1" />
              </Grid>
              <Grid item xs={12} sm={3} mb={2}>
                <FormControl fullWidth>
                  <InputLabel id="townLabel">Town/City</InputLabel>
                  <Select
                    id="town_id"
                    value={formik.values.town_id}
                    name="town_id"
                    fullWidth
                    size="small"
                    variant="outlined"
                    onChange={(e) => {
                      formik.setFieldValue('town_id', e.target.value);
                    }}
                  >
                    <MenuItem key="" value="0">
                      Not Selected
                    </MenuItem>
                    {towns.map((item) => (
                      <MenuItem key={item.town_Id} value={item.town_Id}>
                        {item.town_Name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={3} mb={2}>
                <Controls.Input name="phone1" label="Phone Number" />
              </Grid>
              <Grid item xs={12} sm={3} mb={2}>
                <Controls.Input name="phone2" label="Cell Number" />
              </Grid>
              <Grid item xs={12} sm={3} mb={2}>
                <Controls.DateTime name="termdate" label="Termination Date" />
              </Grid>
            </Grid>
            <div className={classes.root}>
              <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                  className={classes.color}
                >
                  <Typography className={classes.heading}>Payment Details</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={2} marginTop={2}>
                    <Grid item xs={12} sm={4}>
                      <Controls.SelectJson
                        name="tariffs"
                        label="Tarrif in Use"
                        options={tariffTypes}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Controls.SelectJson
                        name="paymentMethod_id"
                        label="Payment Method"
                        options={payoutMethods}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Controls.SelectJson
                        name="frequency"
                        label="Payment Frequency"
                        options={paymentFrequencies}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormControl fullWidth>
                        <InputLabel id="disciplineLabel">Provider Discipline</InputLabel>
                        <Select
                          id="discipline_id"
                          value={formik.values.discipline_id}
                          name="discipline_id"
                          fullWidth
                          size="small"
                          variant="outlined"
                          onChange={(e) => {
                            formik.setFieldValue('discipline_id', e.target.value);
                          }}
                        >
                          <MenuItem key="" value="0">
                            Not Selected
                          </MenuItem>
                          {providerCodes.map((item) => (
                            <MenuItem key={item.disciplinE_ID} value={item.disciplinE_ID}>
                              {item.description}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Controls.SelectJson
                        name="language_id"
                        label="Language"
                        options={languages}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Controls.Input name="email" label="Email Address" />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Controls.Input name="fax" label="Fax Number" />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Controls.Input name="max_authorized_amt" label="Max Authorized Amt" />
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
              <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                  className={classes.color}
                >
                  <Typography className={classes.heading}>Banking Details</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container spacing={2} marginTop={2}>
                    <Grid item xs={12} sm={4}>
                      <FormControl fullWidth>
                        <InputLabel id="bank_IDLabel">Bank</InputLabel>
                        <Select
                          id="bank_id"
                          value={formik.values.bank_id}
                          name="bank_id"
                          fullWidth
                          size="small"
                          variant="outlined"
                          onChange={(e) => {
                            formik.setFieldValue('bank_id', e.target.value);
                          }}
                        >
                          <MenuItem key="" value="0">
                            Not Selected
                          </MenuItem>
                          {banks.map((item) => (
                            <MenuItem key={item.bank_id} value={item.bank_id}>
                              {item.bankName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Controls.Input name="drCode" label="Bank Code" />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormControl fullWidth>
                        <InputLabel id="branchIDLabel">Bank Branch</InputLabel>
                        <Select
                          id="brancH_ID"
                          value={formik.values.brancH_ID}
                          name="brancH_ID"
                          fullWidth
                          size="small"
                          variant="outlined"
                          onChange={(e) => {
                            formik.setFieldValue('brancH_ID', e.target.value);
                          }}
                        >
                          <MenuItem key="" value="0">
                            Not Selected
                          </MenuItem>
                          {bankBranches.map((item) => (
                            <MenuItem key={item.refId} value={item.refId}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Controls.Input name="bankAccount" label="Bank Account" />
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </div>
          </Form>
        </FormikProvider>
      </CardContent>
    </Card>
  );
}
